import * as pdfjsLib from 'pdfjs-dist';
// Note: We'll use a different approach than direct import since the filename has changed
// with newer versions of PDF.js (using .mjs instead of .js)

/**
 * Sets up the PDF.js worker using CDN URLs that match the installed version
 * This is necessary since PDF.js 4.x uses .mjs files which require special handling
 */
const setupPdfWorker = () => {
  console.log('Setting up PDF.js worker, version:', pdfjsLib.version);
  
  try {
    // Use CDN URL with proper file extension (.mjs for version 4.x)
    // This is more reliable for latest PDF.js versions
    const workerUrl = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
    
    // Set the worker source
    pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl;
    
    console.log('PDF.js worker source set to CDN:', workerUrl);
    return true;
  } catch (error) {
    console.error('Failed to set up PDF.js worker with primary method:', error);
    
    try {
      // First fallback: Try using UNPKG CDN
      const unpkgUrl = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
      pdfjsLib.GlobalWorkerOptions.workerSrc = unpkgUrl;
      console.log('PDF.js worker set to fallback CDN:', unpkgUrl);
      return true;
    } catch (fallbackError) {
      console.error('Failed with first fallback:', fallbackError);
      
      // Last resort: Use hard-coded CDN URL with fixed version
      try {
        const fixedUrl = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.269/build/pdf.worker.min.mjs';
        pdfjsLib.GlobalWorkerOptions.workerSrc = fixedUrl;
        console.log('PDF.js worker set to fixed version URL:', fixedUrl);
        return true;
      } catch (lastError) {
        console.error('All worker setup attempts failed');
        return false;
      }
    }
  }
};

// Execute the setup
const isSetupSuccessful = setupPdfWorker();

// Check that the worker is properly initialized
const isWorkerInitialized = () => {
  return pdfjsLib.GlobalWorkerOptions && 
         pdfjsLib.GlobalWorkerOptions.workerSrc;
};

// Utility function to ensure the worker is loaded
export const ensureWorkerIsAvailable = () => {
  if (!isWorkerInitialized()) {
    console.log('Worker not initialized, trying all fallback methods');
    
    // Try using CDN with explicit .mjs extension
    try {
      pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
      console.log('Set worker to primary CDN URL');
      if (isWorkerInitialized()) return true;
      
      // Try UNPKG as fallback
      pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
      console.log('Set worker to UNPKG CDN');
      if (isWorkerInitialized()) return true;
      
      // Last resort - fixed version
      pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.269/build/pdf.worker.min.mjs';
      console.log('Set worker to fixed version URL');
    } catch (error) {
      console.error('All worker initialization attempts failed:', error);
      return false;
    }
  }
  
  return isWorkerInitialized();
};

// Export additional PDF utility functions
export const getMaxPdfSize = () => {
  // 50MB is a reasonable limit for browser-based PDF processing
  return 50 * 1024 * 1024; // 50MB in bytes
};

export { isSetupSuccessful, isWorkerInitialized, pdfjsLib }; 